export const tutorial = {
  quiz: {
    id: 0,
    title: 'Welcome To Trivie',
  },
  assignment_id: 0,
  result: { id: 0, answered: 0, correct_answers: 0 },
  metadata: { assignment_id: 0 },
  test: false,
  tutorial: true,
  items: [
    {
      question_type: 'Multiple Choice',
      id: 1,
      text: 'If you want to jump right into taking quizzes, you should use the ____ tab.',
      image_url: '',
      factoid: {
        text: "If you just want to take a quick quiz and improve your knowledge, you should use the Play tab, which lists every quiz you're enrolled in. The quiz at the top of your list is the one that can boost your learning the most!",
      },
      choices: [
        {
          id: 0,
          correct: false,
          text: 'Lime',
        },
        {
          id: 1,
          correct: false,
          text: 'Library',
        },
        {
          id: 2,
          correct: true,
          text: 'Play',
        },
      ],
    },
    {
      id: 2,
      text: 'Tapping the _____ icon opens your Notification tab.',
      image_url: '',
      factoid: {
        text: 'The Notification tab keeps you in the loop about your Trivie workspace and is represented by a bell.',
      },
      question_type: 'Multiple Choice',
      choices: [
        {
          id: 3,
          correct: true,
          text: 'Bell',
        },
        {
          id: 4,
          correct: false,
          text: 'Bolt',
        },
        {
          id: 5,
          correct: false,
          text: 'Wizard',
        },
      ],
    },
    {
      id: 3,
      text: 'It is impossible to know how your Trivie score stacks up against other learners.',
      image_url: '',
      factoid: {
        text: 'You can visit the Leaderboards tab under Play to compare your Trivie score over the course of the last week, month, or even over all time.',
      },
      question_type: 'True or False',
      choices: [
        {
          id: 6,
          correct: false,
          text: 'True',
        },
        {
          id: 7,
          correct: true,
          text: 'False',
        },
      ],
    },
    {
      id: 5,
      text: 'The Library tab is the best place to view every topic you have access to, along with resources and other important information.',
      image_url: '',
      factoid: {
        text: "Training content on Trivie is broken up into topics, each of which contains quizzes. You can see all of the topics you've been assigned in the Library tab.",
      },
      question_type: 'True or False',
      choices: [
        {
          id: 11,
          correct: true,
          text: 'True',
        },
        {
          id: 12,
          correct: false,
          text: 'False',
        },
      ],
    },
    {
      id: 6,
      text: 'Trivie sends you reinforcement quizzes when it detects that you may have forgotten the answer to a question.',
      image_url: '',
      factoid: {
        text: "Under the hood, Trivie calculates how well you remember each question you've answered. As time passes, we send boosting reinforcement quizzes to help you keep your recall up to snuff.",
      },
      question_type: 'True or False',
      choices: [
        {
          id: 13,
          correct: true,
          text: 'True',
        },
        {
          id: 14,
          correct: false,
          text: 'False',
        },
      ],
    },
    {
      id: 8,
      text: 'My overall ______ score is based on how well I remember the answer to every question I’ve taken in the app.',
      image_url: '',
      factoid: {
        text: 'Your overall recall score is a measure of your likelihood to correctly answer a random question that you’ve already answered at least once. You also have recall scores at the topic and quiz level.',
      },
      question_type: 'Multiple Choice',
      choices: [
        {
          id: 18,
          correct: true,
          text: 'Recall',
        },
        {
          id: 19,
          correct: false,
          text: 'Leaderboard',
        },
        {
          id: 20,
          correct: false,
          text: 'Feed',
        },
      ],
    },
    {
      id: 9,
      text: 'My recall score for a question goes down slower if I answer that question right.',
      image_url: '',
      factoid: {
        text: 'Recall stays higher longer when you answer a question right. Getting a question right more than once in a row keeps your knowledge even fresher. If you get a question wrong, your recall will dip faster – and the question will show up in a Reinforcement Quiz earlier.',
      },
      question_type: 'True or False',
      choices: [
        {
          id: 24,
          correct: true,
          text: 'True',
        },
        {
          id: 25,
          correct: false,
          text: 'False',
        },
      ],
    },
  ],
}

export const subscriptionTutorial = {
  quiz: {
    id: 0,
    title: 'Welcome To Trivie',
  },
  assignment_id: 0,
  result: { id: 0, answered: 0, correct_answers: 0 },
  metadata: { assignment_id: 0 },
  test: false,
  tutorial: true,
  items: [
    {
      question_type: 'Multiple Choice',
      id: 1,
      text: 'If you want to jump right into taking quizzes, you should use the ____ tab.',
      image_url: '',
      factoid: {
        text: "If you just want to take a quick quiz and improve your knowledge, you should use the Play tab, which lists every quiz you're subscribed to. The quiz at the top of your list is the one that can boost your learning the most!",
      },
      choices: [
        {
          id: 0,
          correct: false,
          text: 'Lime',
        },
        {
          id: 1,
          correct: false,
          text: 'Library',
        },
        {
          id: 2,
          correct: true,
          text: 'Play',
        },
      ],
    },
    {
      id: 2,
      text: 'Tapping the _____ icon opens your Notification tab.',
      image_url: '',
      factoid: {
        text: 'The Notification tab keeps you in the loop about your Trivie workspace and is represented by a bell.',
      },
      question_type: 'Multiple Choice',
      choices: [
        {
          id: 3,
          correct: true,
          text: 'Bell',
        },
        {
          id: 4,
          correct: false,
          text: 'Bolt',
        },
        {
          id: 5,
          correct: false,
          text: 'Wizard',
        },
      ],
    },
    {
      id: 3,
      text: 'It is impossible to know how your Trivie score stacks up against other learners.',
      image_url: '',
      factoid: {
        text: 'You can visit the Leaderboards tab under Play to compare your Trivie score over the course of the last week, month, or even over all time.',
      },
      question_type: 'True or False',
      choices: [
        {
          id: 6,
          correct: false,
          text: 'True',
        },
        {
          id: 7,
          correct: true,
          text: 'False',
        },
      ],
    },
    {
      id: 5,
      text: 'The Library tab is the best place to view every topic you have access to, along with resources and other important information.',
      image_url: '',
      factoid: {
        text: 'Training content on Trivie is broken up into topics, each of which contains quizzes. You can see all of the topics you are subscribed to in the Library tab.',
      },
      question_type: 'True or False',
      choices: [
        {
          id: 11,
          correct: true,
          text: 'True',
        },
        {
          id: 12,
          correct: false,
          text: 'False',
        },
      ],
    },
    {
      id: 6,
      text: 'Trivie sends you reinforcement quizzes when it detects that you may have forgotten the answer to a question.',
      image_url: '',
      factoid: {
        text: "Under the hood, Trivie calculates how well you remember each question you've answered. As time passes, we send boosting reinforcement quizzes to help you keep your recall up to snuff.",
      },
      question_type: 'True or False',
      choices: [
        {
          id: 13,
          correct: true,
          text: 'True',
        },
        {
          id: 14,
          correct: false,
          text: 'False',
        },
      ],
    },
    {
      id: 8,
      text: 'My overall ______ score is based on how well I remember the answer to every question I’ve taken in the app.',
      image_url: '',
      factoid: {
        text: 'Your overall recall score is a measure of your likelihood to correctly answer a random question that you’ve already answered at least once. You also have recall scores at the topic and quiz level.',
      },
      question_type: 'Multiple Choice',
      choices: [
        {
          id: 18,
          correct: true,
          text: 'Recall',
        },
        {
          id: 19,
          correct: false,
          text: 'Leaderboard',
        },
        {
          id: 20,
          correct: false,
          text: 'Feed',
        },
      ],
    },
    {
      id: 9,
      text: 'My recall score for a question goes down slower if I answer that question right.',
      image_url: '',
      factoid: {
        text: 'Recall stays higher longer when you answer a question right. Getting a question right more than once in a row keeps your knowledge even fresher. If you get a question wrong, your recall will dip faster – and the question will show up in a Reinforcement Quiz earlier.',
      },
      question_type: 'True or False',
      choices: [
        {
          id: 24,
          correct: true,
          text: 'True',
        },
        {
          id: 25,
          correct: false,
          text: 'False',
        },
      ],
    },
  ],
}
